import React, {Component} from 'react';
import { validateRcsFile, validateAnyRcsFile } from "../../../../util/rcsTypeUtil";

import Modal from '../../../../component/modal/ModalTemplate';

class ImageAddModal extends Component {
    constructor(props) {
        super(props);

        this.handleChangeImage = this.handleChangeImage.bind(this);
        this.handleChangeName = this.handleChangeName.bind(this);
        this.handleClose = this.handleClose.bind(this);

        this.handleButtonClick = this.handleButtonClick.bind(this);

        this.state = {
            quickView: "",
            imgRef: React.createRef(),
            imgWidth: 0,
            imgHeight: 0
        }
    }

    componentWillUnmount() {
        this.disposed = true;
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.state.quickView !== nextState.quickView
            || this.state.imgWidth !== nextState.imgWidth
            || this.state.imgHeight !== nextState.imgHeight
            || this.props.isOpen !== nextProps.isOpen
            || this.props.imgType !== nextProps.imgType
            || this.props.imgName !== nextProps.imgName
        )
    }

    handleChangeImage() {
        const { setValue } = this.props;
        const { imgRef } = this.state;

        const img = imgRef.current.files[0];

        // 3.21 파일 확장자 검사 (jpg, jpeg가 아니면 return)
        if (!img) return;
        const validExtensions = ["jpg", "jpeg"];
        const fileExtension = img.name.split(".").pop().toLowerCase();

        if (!validExtensions.includes(fileExtension)) {
            alert("JPG 또는 JPEG 형식의 파일만 업로드 가능합니다.");
            return;
        }

        const reader = new FileReader();
        reader.readAsDataURL(img);
        reader.onloadend = () => {
            this.setState({ quickView: reader.result });
            // 이미지 모달에서 변경할때 props로 img 넘기지 않는 로직
            // setValue("imgFile", img);

            /* 미리보기 이미지 resize (bizchat 권장 이미지 사이즈: 320x240) */
            const image = new Image();
            image.src = reader.result;
            image.onload = () => {
                let width = image.width;
                let height = image.height;
                let resizeRate = 0;

                if(width > 320) {
                    resizeRate = (1 - (width-320) / width);
                    width = width * resizeRate;
                    height = height * resizeRate;
                }

                if(height > 240) {
                    resizeRate = (1 - (height-240) / height);
                    width = width * resizeRate;
                    height = height * resizeRate;
                }

                this.setState({ imgWidth: width, imgHeight: height })
            };
        }
    }

    handleChangeName(event) {
        const { setValue } = this.props;

        const value = event.target.value;
        setValue("imgName", value);
    }

    handleButtonClick() {
        this.state.imgRef.current.click();
    }

    handleClose() {
        const { handleClose } = this.props;

        this.setState({ quickView: "" });
        handleClose();
    }

    render() {
        const { isOpen } = this.props;
        const { imgType, imgName, imgUploadAction, setValue } = this.props;
        const { quickView, imgRef, imgWidth, imgHeight } = this.state;
        const { handleChangeImage, handleChangeName, handleButtonClick, handleClose } = this;

        return (
            <Modal
                open={isOpen}
                handleClose={handleClose}
                modalTitle={imgType + " 이미지 추가하기"}
                className={"react-modal"}
            >
                <div className={"modal-body"}>
                    <table className="table table-bordered">
                        <tbody className="text-center">
                        <tr>
                            <th className='d-flex justify-content-center'><input
                                type="file"
                                accept="image/jpeg, image/jpg"
                                style={{display: 'none'}}
                                onChange={handleChangeImage}
                                ref={imgRef}
                            />
                                <button
                                    className={"btn btn-primary d-flex align-items-center"}
                                    onClick={handleButtonClick}
                                >
                                    <span className="material-symbols-rounded fs-5 me-2">photo_library</span> 불러오기
                                </button>
                            </th>
                        </tr>
                        <tr>
                            {/*quickview 가 비어있으면 이미지 미리보기 창 보여주기*/}
                            {/*imageType이 MMS냐 RCS냐에 따라 validate가 달라진다.*/}
                            <td>
                                {
                                    quickView === "" ?
                                        <span>이미지 미리보기</span>
                                        : <img width={imgWidth} height={imgHeight} className='img-preload' src={quickView ? quickView : ""} alt=""/>
                                }
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p className='fs-6 fw-normal text-muted text-center'>
                        파일유형 : <strong>jpg, jpeg</strong>뿐입니다. 다른 형식의 파일은 등록할 수 없습니다.
                    </p>
                    <div className={"d-flex align-items-center justify-content-center pb-2"}>
                        <label className='pe-2' htmlFor="imageName">이미지 명</label>
                        <input
                            type="text"
                            className={"form-control w-auto"}
                            id={"imageName"}
                            placeholder={"이미지 명 입력하기"}
                            value={imgName}
                            onChange={handleChangeName}
                        />
                    </div>
                    <hr/>
                    <small className={"text-center"}>* 등록한 이미지는 최대 1년간 보관되며, 1년이 지나면 자동으로 삭제됩니다.</small>
                </div>
                <div className={"modal-footer"}>
                    <button className={"btn btn-primary btn-md mx-2"} onClick={async () => {
                        // 추가 버튼을 눌렀을때 이미지 변경 사항 전달
                        const file = imgRef.current.files[0];
                        if (!file) return;
                        if (imgType === 'RCS') {
                            const valid = this.props.rcsType !== undefined
                                ? await validateRcsFile(file, this.props.rcsType)
                                : await validateAnyRcsFile(file);
                            if (!valid) return;
                        }
                        if (this.disposed || !this.props.isOpen || imgRef.current?.files[0] !== file) return;
                        await setValue("imgFile", file);
                        imgUploadAction();
                        handleClose();
                    }}>추가</button>
                    <button className={"btn btn-secondary btn-md"} onClick={handleClose}>취소</button>
                </div>
            </Modal>
        )
    }
}

ImageAddModal.defaultProps = {
    isOpen: false,
    handleClose: function () {},
    setValue: function () {},
    imgUploadAction: function () {},
    imgType: 'MMS',
    imgName: '',
}

export default ImageAddModal;
